var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Button",class:'Button_' + _vm.size},[(_vm.href)?_c('a',{attrs:{"href":_vm.href},on:{"click":function($event){return _vm.Submit($event)}}},[_vm._t("default")],2):_c('button',{attrs:{"type":_vm.mode},on:{"click":function($event){return _vm.Submit($event)}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }